module.exports = __webpack_public_path__ + "img/model_ug_66.f40a7967.png";